import { jsx as _jsx } from "react/jsx-runtime";
import { IconInfo } from "@consta/icons/IconInfo";
import { SnackBar } from "@consta/uikit/SnackBar";
import { useShallow } from "zustand/react/shallow";
import { useNotificationStore } from "../../../core/services/stores/notificationStore/store";
import { SECONDS_TO_CLOSE_SNACK } from "../../const/consts";
import styles from "./CustomSnackBar.module.scss";
import { IconsMap } from "./utils/snack-icons-map";
var CustomSnackBar = function () {
    var _a = useNotificationStore(useShallow(function (state) { return ({
        snackBarItems: state.snackBarItems,
        closeSnack: state.closeSnack,
    }); })), snackBarItems = _a.snackBarItems, closeSnack = _a.closeSnack;
    var getItemShowProgress = function (item) { return item.progressMode; };
    var getIcon = function (item) {
        if (!item.status)
            return IconInfo;
        var icon = IconsMap[item.status];
        if (!icon)
            return IconInfo;
        return icon;
    };
    return (_jsx(SnackBar, { className: styles.snackbar, items: snackBarItems, getItemStatus: function (item) { return item.status; }, getItemKey: function (item) { var _a; return (_a = item.id) !== null && _a !== void 0 ? _a : item.label; }, getItemAutoClose: function () { return SECONDS_TO_CLOSE_SNACK; }, getItemMessage: function (item) { return item.message; }, getItemShowProgress: getItemShowProgress, onItemClose: closeSnack, getItemIcon: getIcon }));
};
export default CustomSnackBar;
